import { styled } from '@mui/material';
import Grid2 from '@mui/material/Grid2';

const PREFIX = 'FirmSettings';

export const classes = {
  firmLogoContainer: `${PREFIX}-firmLogoContainer`,
  helperText: `${PREFIX}-helperText`,
  textField: `${PREFIX}-textField`,
  checkBoxContainer: `${PREFIX}-checkBoxContainer`,
  checkBoxLabel: `${PREFIX}-checkBoxLabel`,
};

export const StyledGrid = styled(Grid2)(({ theme }) => ({
  [`& .${classes.firmLogoContainer}`]: {
    marginTop: '-2rem',
  },

  [`& .${classes.helperText}`]: {},

  [`& .${classes.textField}`]: {
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      color: theme.palette.primary[700],
      fontSize: '1rem',
    },
  },

  [`& .${classes.checkBoxContainer}`]: {
    display: 'block',
  },

  [`& .${classes.checkBoxLabel}`]: {
    display: 'initial',
  },
}));